import { InsertLinksHost } from 'owa-attachment-link-common';
import { ComposeViewState } from 'owa-mail-compose-store';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';

export function getInsertLinksHost(composeViewState: ComposeViewState): InsertLinksHost {
    return {
        attachmentWell: {
            ...composeViewState.attachmentWell,
            logTraceId: composeViewState.logTraceId,
        },
        getRecipientWells: (): RecipientWellWithFindControlViewState[] => [
            composeViewState.toRecipientWell,
            composeViewState.ccRecipientWell,
            composeViewState.bccRecipientWell,
        ],
    };
}
